import React from "react";
import {
  StewartDialog,
  StewartDialogActions,
} from "controls/global/dialogs/stewart-dialog/StewartDialog";
import { Box, IconButton, Typography, styled } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  borderRadius,
  colors,
  fontSize,
  fontWeight,
  gradients,
  iconSize,
  margin,
  padding,
} from "theme/defaultStyle";
import ActionButton from "controls/global/action-button";
import { Message } from "entities/UIModel";
import ViewContractIcon from "theme/icons/ViewContractIcon";

const StyledDialog = styled(StewartDialog)({
  "& > .MuiDialog-container > .MuiDialog-paper": {
    maxHeight: "calc(98vh)",
    maxWidth: "calc(40vw)",
    minWidth: "calc(40vw)",
    display: "flex",
    justifyContent: "flex-start",
    padding: "36px 40px 0px 40px",
    overflowX: "auto",
  },
});

const StyledDialogTitle = styled(Box)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  columnGap: "24px",
  "& .MuiTypography-root": {
    fontSize: fontSize.xlarge2,
    fontWeight: fontWeight.bold2,
  },
});

const IconContainer = styled("div")({
  background: gradients.blueGradient09,
  borderRadius: borderRadius.large,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "56px",
  height: "56px",
  "& .MuiSvgIcon-root": {
    color: colors.white,
    fontSize: iconSize.medium2,
  },
});

const StyledDialogAction = styled(StewartDialogActions)({
  justifyContent: "right",
  paddingBottom: padding.xlarge22,
  paddingTop: padding.xlarge1,
  paddingRight: padding.zero,
  paddingLeft: padding.zero,
});

const CloseIconContainer = styled("div")({
  background: colors.grey10,
  borderRadius: borderRadius.xlarge1,
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  marginLeft: "auto",
  marginBottom: "auto",
  width: "32px",
  height: "32px",
  padding: "4px",
  "& .MuiSvgIcon-root": {
    color: colors.blue01,
    width: "24px",
    height: "24px",
  },
  "& .iconButton": {
    padding: padding.zero,
    backgroundColor: colors.grey10,
  },
});

const MessageContainer = styled(Box)({
  border: `1px solid ${colors.grey07}`,
  borderRadius: borderRadius.medium,
  padding: padding.medium1,
  marginTop: margin.xlarge1,
  position: "relative",
  backgroundColor: colors.grey03,
  // minHeight: "200px",
  maxHeight: "calc(95vh)",
  maxWidth: "calc(50vw)",
});

const MessageLabel = styled(Typography)({
  position: "absolute",
  top: "-10px",
  height: "12px",
  color: colors.grey06,
  fontSize: fontSize.small,
  backgroundColor: "white",
  marginBottom: margin.zero,
  paddingBottom: padding.zero,
});

const MessageText = styled(Box)({
  wordBreak: "break-word",
  whiteSpace: "pre-wrap",
  overflowWrap: "break-word",
  fontSize: fontSize.medium,
  color: colors.grey07,
  //minHeight: "70vh0px",
  maxHeight: "60vh",
  overflow: "auto",
});


interface ViewMessageDialogProps {
  isOpen: boolean;
  onClose: () => void;
  message: (Message & { isToggled?: boolean }) | null;
}

const ViewMessageDialog = ({
  isOpen,
  onClose,
  message,
}: ViewMessageDialogProps) => {
  function handleOnClose() {
    onClose && onClose();
  }

  return (
    <>
      <StyledDialog open={isOpen}>
        <StyledDialogTitle id="styledDialogTitleDebug">
          <IconContainer>
            <ViewContractIcon />
          </IconContainer>
          <Typography id="uploadPolicyImageTitleDebug">
            View Full Message
          </Typography>
          <CloseIconContainer>
            <IconButton className="iconButton" onClick={handleOnClose}>
              <CloseIcon />
            </IconButton>
          </CloseIconContainer>
        </StyledDialogTitle>
        <MessageContainer>
          <MessageLabel>Message</MessageLabel>
          <MessageText>
            {message?.messageText || "No message found."}
          </MessageText>
        </MessageContainer>

        <StyledDialogAction className="DialogAction">
          <ActionButton
            variant="outlined"
            color="primary"
            onClick={handleOnClose}
          >
            Close
          </ActionButton>
        </StyledDialogAction>
      </StyledDialog>
    </>
  );
};

export default ViewMessageDialog;
